<template>
  <div id="comp-loading">
    <div class="loading-wrapper" v-if="fullscreen">
      <div class="loading-container">
        <div class="lds-css ng-scope">
          <div
            style="width: 100%; height: 100%; margin: 0 auto"
            class="lds-rolling"
          >
            <div></div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-spinner" v-else>
      <div class="spinner-container"><div></div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompLoading',
  props: {
    fullscreen: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/comp-loading.scss" scoped></style>
